import { NgModule, Optional, SkipSelf } from "@angular/core";
import { CookieModule } from 'ngx-cookie';
import { throwIfAlreadyLoaded } from "../module-import-guard";

import { AnalyticsService } from './analytics.service';
import { CampaignsService } from './campaigns.service';
import { EnumsService } from './enums.service';
import { LinesService } from './lines.service';
import { LoginService } from './login.service';
import { MeasuresService } from "./measures.service";
import { ObservationsService } from "./observations-service";
import { ObservationTypesService } from "./observation-types.service";
import { PksService } from './pks.service';
import { SettingsService } from './settings.service';
import {AppInfosService} from "./app-infos.service";

@NgModule({
  imports: [
    CookieModule.forRoot(),
  ],
  providers: [
    AnalyticsService,
    CampaignsService,
    EnumsService,
    LinesService,
    LoginService,
    MeasuresService,
    ObservationsService,
    ObservationTypesService,
    PksService,
    SettingsService,
    AppInfosService
  ]
})
export class DataCoreModule {
  constructor(@Optional() @SkipSelf() parentModule: DataCoreModule) {
    throwIfAlreadyLoaded(parentModule, 'DataCoreModule');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/data-core.module.ts